import React from 'react';
import classnames from 'classnames';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ children, className }) => (
  <div className={classnames('page', className)}>{children}</div>
);
